/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'
import { Button, Row, Col } from 'reactstrap'
import {matchSorter} from 'match-sorter'
import {CopyToClipboard} from 'react-copy-to-clipboard';

import ContentGallery from './ContentGallery'
import VaultViewData from './VaultViewData';
import QueryBuilder from './QueryBuilder.js'
import VaultViewButtonBar from './VaultViewButtonBar'
import VaultViewModal from './VaultViewModal.js'
import ObjectModal from './objects/ObjectModal.js'
import UploadFiles from '../widgets/UploadFiles'
import ConfirmationModal from '../widgets/ConfirmationModal'

import prettyBytes from 'pretty-bytes';

import {AppContext} from '../AppContext';

class VaultViewTab extends React.Component
{
  prettyBytes = require('pretty-bytes');

  vaultColumnWidths = {};
  disableSelectionHandler = false;
  mediaList = [];
  visibleColumnsLS = undefined;
  columnWidthsLS = undefined;
  sortColumnLS = undefined;
  activeObjectModalTabLS = undefined;
  selectedObjects = [];
  currentViewIndex = undefined;
  tableRefs = [];
  activeObjectModalTab = 0;
  closeConfirmationModal = null;
  objectTypeIds = [];
  selectedKeywordsAndValues = [];
  selectedObjectIds = [];

  clearSelectedRows()
  {
    this.currentViewIndex = undefined;
    this.setState({selectedRows: []});
  }

  closeContentGallery()
  {
    this.disableSelectionHandler = false;
    this.setState({ contentGalleryIsOpen: false });
  }

  columnPickerChanged(option, actionMetaD)
  {
    let columnPickerData = this.state.columnPickerData.slice();
    let vaultColumns = this.state.vaultColumns.slice();

    // flip checkbox/selected status
    //
    let i = 0; // needed below this loop
    for (; i < columnPickerData.length; i++)
    {
      if (columnPickerData[i].value === option.value)
      {
        columnPickerData[i].selected = !columnPickerData[i].selected;
        break;
      }
    }

    // change corresponding column visibility
    if (columnPickerData[i].selected)
      vaultColumns[columnPickerData[i].value].show = true;
    else
      vaultColumns[columnPickerData[i].value].show = false;

    // store in browser local storage
    let vaultVisibleColumns = [];
    for (i = 0; i < vaultColumns.length; i++)
    {
      if (vaultColumns[i].show)
        vaultVisibleColumns.push(vaultColumns[i].id);
    }
    this.context.appLocalStorage.setItem(this.visibleColumnsLS, JSON.stringify(vaultVisibleColumns));

    // store new state
    this.setState({
      columnPickerData: columnPickerData,
      vaultColumns: vaultColumns,
    });
  }

  componentDidMount()
  {
    let showKeywordList = ('uncataloged' === this.props.viewType ? false : true);
    let showViewButton = ('deleted' === this.props.viewType ? false : true);
    let showName = ('shared' === this.props.viewType ? true : false);

    let x = 0;
    let vaultColumns =
    [
      {Header: 'Source', id: 'sourcePath', accessor: 'sourcePath', show: false, toggleVisibility: true, index: x++,
        Cell: row => <div><span title={row.value}>{row.value}</span></div>, filterAll: true,
        filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ["sourcePath"] })},
      {Header: 'Name', id: 'objectName', accessor: 'objectName', show: true, toggleVisibility: true, index: x++,
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'Object Type', id: 'objectType', accessor: 'objectType', show: true, toggleVisibility: true, index: x++,
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'Creation Date', id: 'creationDate', accessor: d => {return d.creationDate}, show: true, toggleVisibility: true, index: x++,
        Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.creationDate, true)}>{window.formatTimestamp(rowInfo.row.creationDate, false)}</span></div>),
        filterMethod: (filter, row) =>
        {
          if (null === row.creationDate) return false;
          if (-1 !== window.formatTimestamp(row.creationDate).indexOf(filter.value)) return true;
          return false;
        }
      },
      {Header: 'Last Mod', id: 'modificationDate', accessor: d => {return d.modificationDate}, show: true, toggleVisibility: true, index: x++,
        Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.modificationDate, true)}>{window.formatTimestamp(rowInfo.row.modificationDate, false)}</span></div>),
        filterMethod: (filter, row) =>
        {
          if (null === row.modificationDate) return false;
          if (-1 !== window.formatTimestamp(row.modificationDate).indexOf(filter.value)) return true;
          return false;
        }
      },
      {Header: 'File Ext.', id: 'fileExtension', accessor: 'fileExtension', show: false, toggleVisibility: true, index: x++},
      {Header: 'Creation Method', id: 'creationMethod', accessor: 'creationMethod', show: false, toggleVisibility: true, index: x++,
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'Gateway', id: 'gateway', accessor: 'gateway', show: false, toggleVisibility: true, index: x++,
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'Source Program', id: 'programUsedToCreate',  accessor: 'programUsedToCreate', show: false, toggleVisibility: true, index: x++,
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'MIME Type', id: 'mimeType', accessor: 'mimeType', show: false, toggleVisibility: true, index: x++,
        Cell: row => <div><span title={row.value}>{row.value}</span></div>},
      {Header: 'Last Access', id: 'lastAccessDate', accessor: d => {return d.lastAccessDate}, show: true, toggleVisibility: true, index: x++,
        Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.lastAccessDate, true)}>{window.formatTimestamp(rowInfo.row.lastAccessDate, false)}</span></div>),
        filterMethod: (filter, row) =>
        {
          if (null === row.lastAccessDate) return false;
          if (-1 !== window.formatTimestamp(row.lastAccessDate).indexOf(filter.value)) return true;
          return false;
        }
      },
      {Header: 'Last Metadata Change', id: 'lastMetadataChangeDate', accessor: d => {return d.lastMetadataChangeDate}, show: false, toggleVisibility: true, index: x++,
        Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.lastMetadataChangeDate, true)}>{window.formatTimestamp(rowInfo.row.lastMetadataChangeDate, false)}</span></div>),
        filterMethod: (filter, row) =>
        {
          if (null === row.lastMetadataChangeDate) return false;
          if (-1 !== window.formatTimestamp(row.lastMetadataChangeDate).indexOf(filter.value)) return true;
          return false;
        }
      },
      {Header: 'Ingested File CDate', id: 'ingestedFileCDate', accessor: d => {return d.ingestedFileCDate}, show: false, toggleVisibility: true, index: x++,
        Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.ingestedFileCDate, true)}>{window.formatTimestamp(rowInfo.row.ingestedFileCDate, false)}</span></div>),
        filterMethod: (filter, row) =>
        {
          if (null === row.ingestedFileCDate) return false;
          if (-1 !== window.formatTimestamp(row.ingestedFileCDate).indexOf(filter.value)) return true;
          return false;
        }
      },
      {Header: 'Ingested File MDate', id: 'ingestedFileMDate', accessor: d => {return d.ingestedFileMDate}, show: false, toggleVisibility: true, index: x++,
        Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.ingestedFileMDate, true)}>{window.formatTimestamp(rowInfo.row.ingestedFileMDate, false)}</span></div>),
        filterMethod: (filter, row) =>
        {
          if (null === row.ingestedFileMDate) return false;
          if (-1 !== window.formatTimestamp(row.ingestedFileMDate).indexOf(filter.value)) return true;
          return false;
        }
      },
      {Header: 'Ingested File ADate', id: 'ingestedFileADate', accessor: d => {return d.ingestedFileADate}, show: false, toggleVisibility: true, index: x++,
        Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.ingestedFileADate, true)}>{window.formatTimestamp(rowInfo.row.ingestedFileADate, false)}</span></div>),
        filterMethod: (filter, row) =>
        {
          if (null === row.ingestedFileADate) return false;          
          if (-1 !== window.formatTimestamp(row.ingestedFileADate).indexOf(filter.value)) return true;
          return false;
        }
      },
      {Header: 'Keyword List', id: 'keywordList', accessor: 'keywordList', show: showKeywordList, toggleVisibility: showKeywordList, index: x++,
        Cell: row => (<div><span title={row.value}>{row.value}</span></div>),
        filterMethod: (filter, row) =>
        {
          if (null === row.keywordList) return false;
          if (-1 !== row.keywordList.indexOf(filter.value)) return true;
          return false;
        }
      },
      {Header: 'Versioned Obj.', id: 'versionedObject', accessor: 'versionedObject', show: false, toggleVisibility: true, index: x++},
      {Header: 'Immutable Obj.', id: 'immutableObject', accessor: 'immutableObject', show: false, toggleVisibility: true, index: x++},
      {Header: 'Immutable Keys', id: 'immutableKeywords', accessor: 'immutableKeywords', show: false, toggleVisibility: true, index: x++},
      {Header: 'Share Status', id: 'shareStatus', accessor: 'shareStatus', show: false, toggleVisibility: true, index: x++},
      {Header: 'Owner', id: 'ownerName', accessor: 'ownerName', show: showName, toggleVisibility: showName, index: x++},
      {Header: 'Size', id: 'contentLength', accessor: 'contentLength', show: false, toggleVisibility: true, index: x++, 
        Cell: row => (<div><span title={new Intl.NumberFormat().format(parseInt(row.value, 10)) + ' Bytes'}>{prettyBytes(parseInt(row.value, 10))}</span></div>),
        sortMethod: (a, b, desc) =>
        {
          if (a > b)
            return 1;
          else
            return -1;
        }
      }
    ]

    if (undefined !== this.props.installedExtensions && window.extensionInstalled(this.props.installedExtensions, 'OCIObjectStorage'))
      vaultColumns.push({Header: 'Storage Tier', id: 'storageTier', accessor: 'storageTier', show: false, toggleVisibility: true, index: x++});

    if (window.extensionEnabled(this.context.websiteProfile.installedExtensions, this.context.extensions.AI))
    {
      vaultColumns = vaultColumns.concat(
      [
        {Header: 'Embeddings Generated', id: 'embeddingsGenerated', accessor: 'embeddingsGenerated', show: false, toggleVisibility: true, index: x++,
          Cell: row => <div><span title={row.value}>{row.value}</span></div>},
        {Header: 'Embedding Date', id: 'embeddingDate', accessor: d => {return d.embeddingDate}, show: false, toggleVisibility: true, index: x++,
          Cell: rowInfo => (<div><span title={window.formatTimestamp(rowInfo.row.embeddingDate, true)}>{window.formatTimestamp(rowInfo.row.embeddingDate, false)}</span></div>),
          filterMethod: (filter, row) =>
          {
            if (null === row.embeddingDate) return false;          
            if (-1 !== window.formatTimestamp(row.embeddingDate).indexOf(filter.value)) return true;
            return false;
          }
        },
        {Header: 'Vector Modality', id: 'vectorModality', accessor: 'vectorModality', show: false, toggleVisibility: true, index: x++,
          Cell: row => <div><span title={row.value}>{row.value}</span></div>}
      ]);
    }

    vaultColumns = vaultColumns.concat(
    [
      {Header: 'Object Id', id: 'objectId', accessor: 'objectId', show: false, toggleVisibility: true, index: x++,
      Cell: row => (
        <CopyToClipboard text={row.value} onCopy={() => this.context.postNotification('info', 'Object ID copied to paste buffer.')}>
          <Button title={row.value}>Copy Object-Id</Button></CopyToClipboard>)
      },
      {Header: 'View/Play', id: 'viewObject', show: showViewButton, toggleVisibility: showViewButton, filterable: false, index: x++, 
        Cell: (rowInfo) => 
        { 
          if (null !== rowInfo.row.htmlElement && 'ReactJson' !== rowInfo.row.htmlElement)
          {
            return (
              <div className="text-center">
                <Button className="btn-sm" color="primary" onClick={this.viewButtonHandlerEntry.bind(this, rowInfo)}>View/Play</Button>
              </div>
            );
          }
          else
            return null;
        }
      },
      {accessor: 'objectTypeId', show: false, toggleVisibility: false},
      {accessor: 'htmlElement', show: false, toggleVisibility: false},
      {accessor: 'extensionId', show: false, toggleVisibility: false},
      {accessor: 'versionsToRetain', show: false, toggleVisibility: false},
      {accessor: 'versionsHaveSameName', show: false, toggleVisibility: false}
    ]);

    this.vaultColumnWidths = this.context.appLocalStorage.getColumnWidths(vaultColumns, this.columnWidthsLS);

    // reload stored vault visible columns
    //
    let savedVisibleColumns = JSON.parse(this.context.appLocalStorage.getItem(this.visibleColumnsLS));
    if (savedVisibleColumns !== null && 'null' !== savedVisibleColumns)
    {
      for (let i = 0; i < vaultColumns.length; i++)
      {
        let foundColumn = false;
        for (let j = 0; j < savedVisibleColumns.length; j++)
        {
          if (vaultColumns[i].id === savedVisibleColumns[j])
          {
            vaultColumns[i].show = true;
            foundColumn = true;
            break;
          }
        }
        if (!foundColumn)
          vaultColumns[i].show = false;
      }
    }

    let columnPickerData = [];
    let y = 0;
    for (let x = 0; x < vaultColumns.length; x++)
    {
      if (vaultColumns[x].toggleVisibility) 
      {
        columnPickerData[y] = 
          { label: vaultColumns[x].Header, value: vaultColumns[x].index, 
            selected: vaultColumns[x].show};
        y++;
      }
    }

    columnPickerData.sort(function(a, b)
    {
      if (a.label < b.label) return -1;
      if (a.label > b.label) return 1;
      return 0;
    });

    let sortColumn = JSON.parse(this.context.appLocalStorage.getItem(this.sortColumnLS))
    if (null === sortColumn) sortColumn = undefined;

    this.activeObjectModalTab = Number(this.context.appLocalStorage.getItem(this.activeObjectModalTabLS));
    
    this.setState(
    {
      vaultColumns: vaultColumns,
      sortColumn: sortColumn,
      columnPickerData: columnPickerData
    });

    this.getAcceptableTypes();
  }

  constructor(props)
  {
    super();

    this.visibleColumnsLS = 'vaultViewTab.' + props.tabIndex + '.visibleColumns';
    this.columnWidthsLS = 'vaultViewTab.'  + props.tabIndex + '.columnWidths';
    this.sortColumnLS = 'vaultViewTab.' + props.tabIndex + '.sortColumn';
    this.activeObjectModalTabLS = 'vaultViewTab.' + props.tabIndex + '.activeObjectModalTab';
  
    this.state =
    {
      sortColumn: undefined,
      selectedRows: [],
      columnPickerData: [],
      vaultColumns: [],
      contentGalleryIsOpen: false,
      objectTypePlaceholder: 'All Object Types',
      objectModalIsOpen: false,
      objectModalRowInfo: undefined,
      vaultViewModalIsOpen: false,
      vaultViewModalComponent: undefined,
      enableZoom: true,
      enableColumnFilters: false,
      acceptableTypes: undefined,
      confirmationModalIsOpen: false,
      modalText: ''
    }

    this.uploadComplete = this.uploadComplete.bind(this);
    this.keywordsButtonHandler = this.keywordsButtonHandler.bind(this);
    this.keywordsContextMenuHandler = this.keywordsContextMenuHandler.bind(this);
    this.enrollButtonHandler = this.enrollButtonHandler.bind(this);
    this.vaultViewModalClosed = this.vaultViewModalClosed.bind(this);
    this.objectTypePickerChanged = this.objectTypePickerChanged.bind(this);
    this.columnPickerChanged = this.columnPickerChanged.bind(this);
    this.filterDataChanged = this.filterDataChanged.bind(this);
    this.matchAnyOrAllChanged = this.matchAnyOrAllChanged.bind(this);
    this.saveQueryFilter = this.saveQueryFilter.bind(this);
    this.removeQueryFilter = this.removeQueryFilter.bind(this);
    this.closeContentGallery = this.closeContentGallery.bind(this);
    this.openContentGallery = this.openContentGallery.bind(this);
    this.toggleSelectedRows = this.toggleSelectedRows.bind(this);
    this.toggleColumnFilters = this.toggleColumnFilters.bind(this);
    this.selectionHandler = this.selectionHandler.bind(this);
    this.objectModalClosed = this.objectModalClosed.bind(this);
    this.openDetailsModal = this.openDetailsModal.bind(this);
    this.deleteRestoreOrPurge = this.deleteRestoreOrPurge.bind(this);
    this.transformObject = this.transformObject.bind(this);
    this.refreshVaultViewTab = this.refreshVaultViewTab.bind(this);
    this.secureWeblinkButtonHandler = this.secureWeblinkButtonHandler.bind(this);
    this.saveColumnWidths = this.saveColumnWidths.bind(this);
    this.sortChanged = this.sortChanged.bind(this);
    this.removeKeywords = this.removeKeywords.bind(this);
    this.setActiveObjectModalTab = this.setActiveObjectModalTab.bind(this);
    this.toggleImmutableObject = this.toggleImmutableObject.bind(this);
    this.setStorageTier = this.setStorageTier.bind(this);
    this.setTableRef = this.setTableRef.bind(this);
    this.sharingButtonHandler = this.sharingButtonHandler.bind(this);
    this.sharedOptionChanged = this.sharedOptionChanged.bind(this);
    this.toggleCaptureDetail = this.toggleCaptureDetail.bind(this);
    this.generateEmbeddings = this.generateEmbeddings.bind(this);
    this.openChatInterface = this.openChatInterface.bind(this);
    this.closeConfirmationModal = this.generateEmbeddingsConfirmed.bind(this);
    this.imageSearch = this.imageSearch.bind(this);
  }

  /**
    * Deletes or restores all currently selected objects
    *
    */
  async deleteRestoreOrPurge(buttonType)
  {
    this.getSelectedObjects();
    if (!this.selectedObjects.length) return;

    if (this.immutableObjectCheck('object')) return;

    let bodyData = { objectIds: [] };
    for (let i = 0; i < this.selectedObjects.length; i++) bodyData.objectIds.push(this.selectedObjects[i].objectId);
    var url;
    var text;

    if ('purge' === buttonType)
      url = 'purgeDeletedObjects';
    else
      url = this.props.viewType === 'deleted' ? 'restoreObjects' : 'deleteObjects';

    let result = await this.context.dbTwig.callRestAPI('dgBunker', url, bodyData);
    if ('success' !== result.status)
    {
      if ('purge' === buttonType)
        text = 'purge';
      else
        text = (this.props.viewType === 'deleted' ? 'restore' : 'delete');

      return this.context.dbTwig.apiErrorHandler(result, 'Unable to ' + text + ' object');
    } 

    if ('purge' === buttonType) text = (1 < this.selectedObjects.length ? 'Objects purged.' : 'Object purged.');
    if ('delete' === buttonType) text = (1 < this.selectedObjects.length ? 'Objects deleted.' : 'Object deleted.');
    if ('restore' === buttonType) text = (1 < this.selectedObjects.length ? 'Objects restored.' : 'Object restored.');

    this.context.postNotification('info', text);
    this.clearSelectedRows();
    this.refreshVaultViewTab();
  }

  enrollButtonHandler()
  {
    this.setState({vaultViewModalComponent: 'enroll', vaultViewModalIsOpen: !this.state.vaultViewModalIsOpen});
  }
    
  filterDataChanged(index, filterData)
  {
    this.clearSelectedRows();
    this.props.filterDataChanged(this.props.tabIndex, index, filterData)
  }
  
  formatDateValue(dateValue)
  {
    if (null === dateValue) return null;
    return window.moment.unix(dateValue).utc().local().format('LL LTS');
  }

  generateEmbeddings()
  {
    this.selectedKeywordsAndValues = [];
    if (undefined !== this.props.filterData)
    {
      if (undefined !== this.props.filterData[0].queryKeyword)
      {
        for (let y = 0; y < this.props.filterData.length; y++)
        {
          let selectedKeywordAndValue = {keywordId: null, valueId: null, operator: this.props.filterData[y].operator.value};
          if (null !== this.props.filterData[y].queryKeyword)
          {
            selectedKeywordAndValue.keywordId = this.props.filterData[y].queryKeyword.keywordId;
            if (null !== this.props.filterData[y].queryValue) selectedKeywordAndValue.valueId = this.props.filterData[y].queryValue.valueId;
            this.selectedKeywordsAndValues[this.selectedKeywordsAndValues.length] = selectedKeywordAndValue;
          } 
        }
      }
    }

    this.objectTypeIds = [];

    for (let x = 0; x < this.props.objectTypePickerData.length; x++)
    {
      if (this.props.objectTypePickerData[x].selected && x)   // Including test for x filters out the first entry which corresponds to 'all' data types.
        this.objectTypeIds[this.objectTypeIds.length] = this.props.objectTypePickerData[x].objectTypeId;
    }

    this.getSelectedObjects();
    this.selectedObjectIds = [];
    if (!this.selectedObjects.length && 'uncataloged' === this.props.viewType)
    {
      this.context.postNotification('error', 'Select one or more objects first.');
      return;
    }
    if (!this.selectedObjects.length && 'cataloged' === this.props.viewType && 
        !this.selectedKeywordsAndValues.length && !this.objectTypeIds.length)
    {
      this.context.postNotification('error', 'Unrestricted generation of embeddings disabled. You must select some objects or otherwise narrow down the list.')
      return;
    }
    for (let x = 0; x < this.state.selectedRows.length; x++)
    {
      if (null !== this.props.vaultViewData[this.state.selectedRows[x]].vectorModality) 
        this.selectedObjectIds.push(this.props.vaultViewData[this.state.selectedRows[x]].objectId);
    }

    let modalText = this.selectedObjectIds.length === this.selectedObjects.length ? 'Are you sure you want to generate vector embeddings for the selected objects?' :
      'Not all of the selected objects can have vector embeddings generated for them. Are you sure you want to continue?';

    this.setState({modalText, modalIsOpen: true});
  }

  async generateEmbeddingsConfirmed(confirmed)
  {
    this.setState({modalIsOpen: false});
    if (!confirmed) return;

    let bodyData = 
    {
      viewType: this.props.viewType,
      selectedObjectIds: this.selectedObjectIds,
      selectedKeywordsAndValues: this.selectedKeywordsAndValues,
      objectTypeIds: this.objectTypeIds
    }
    if (undefined !== this.props.matchAnyOrAll) bodyData.matchAnyOrAll = this.props.matchAnyOrAll;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'createEmbeddingsRequest', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error submitting embedding request');
    this.context.postNotification('success', 'Embedding generation request submited.'); 
  }

  async generateWeblink(objectId, htmlElement, callback)
  {
    let bodyData = {objectId: objectId, contentDisposition: 'STREAM'};
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'generateObjectWeblink', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error generating weblink');
    callback(result.jsonData.objectWeblink, htmlElement);
  }

  async getAcceptableTypes()
  {
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'getAcceptableObjectTypes');
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error getting acceptable object types');
    this.setState({acceptableTypes: result.jsonData.acceptableTypes});
  }
  
  getSelectedObjects()
  {
    this.selectedObjects = [];
    if (!this.state.selectedRows.length) return null;
    for (let x = 0; x < this.state.selectedRows.length; x++) this.selectedObjects.push(this.props.vaultViewData[this.state.selectedRows[x]]);
  }

  imageSearch()
  {
    this.getSelectedObjects();
    if (1 < this.selectedObjects.length) this.context.postNotification('info', 'Note: Your image search is limited to the selected objects');
    if (1 === this.selectedObjects.length) this.context.postNotification('warning', 'Note: Your image search is limited to a single object');
    this.setState({vaultViewModalComponent: 'imageSearch', vaultViewModalIsOpen: !this.state.vaultViewModalIsOpen});
  }

  immutableObjectCheck(objectOrKeywords)
  {
    for (let x = 0; x < this.selectedObjects.length; x++)
    {
      if (('object' === objectOrKeywords && 'Y' === this.selectedObjects[x].immutableObject) ||
          ('keywords' === objectOrKeywords && 'Y' === this.selectedObjects[x].immutableKeywords))
      {
        this.context.postNotification('error', 'One or more selected rows is immutable.');
        return true;
      }
    }

    return false;
  }

  keywordsButtonHandler()
  {
    this.getSelectedObjects();
    if (!this.selectedObjects.length)
    {
      this.context.postNotification('error', 'Select an object first.');
      return;
    }

    this.setState({vaultViewModalComponent: 'keywords', vaultViewModalIsOpen: !this.state.vaultViewModalIsOpen});
  }

  keywordsContextMenuHandler(row)
  {
    this.getSelectedObjects();
    if (!this.selectedObjects.length) this.selectedObjects.push(row);

    this.setState({vaultViewModalComponent: 'keywords', vaultViewModalIsOpen: !this.state.vaultViewModalIsOpen});
  }

  matchAnyOrAllChanged(matchAnyOrAll)
  {
    this.clearSelectedRows();
    this.props.matchAnyOrAllChanged(this.props.tabIndex, matchAnyOrAll)
  }

  objectModalClosed()
  {
    this.setState({objectModalIsOpen: !this.state.objectModalIsOpen});
  }

  openDetailsModal(rowInfo, rowIndex)
  {
    // this happens when the click was on a non-row, it's garbage we want to ignore
    if (rowInfo === null)
    {
      window.clearTextSelection();
      return;
    }

    if (typeof rowInfo === 'undefined')
    { 
      this.context.postNotification('info', 'Please select an object first.');
      return;
    }

    rowInfo.rowIndex = rowIndex;
    this.setState({objectModalRowInfo: rowInfo, objectModalIsOpen: true});
  }

  openChatInterface()
  {
    this.getSelectedObjects();
    if (this.selectedObjects.length) this.context.postNotification('info', 'Note: Your RAG content is limited by selected objects');
    this.setState({vaultViewModalComponent: 'chatInterface', vaultViewModalIsOpen: !this.state.vaultViewModalIsOpen});
  }

  objectTypePickerChanged(selectedOption, actionMetaD)
  {
    this.clearSelectedRows();
    this.props.objectTypePickerChanged(this.props.tabIndex, selectedOption);
  }

  refreshVaultViewTab()
  {
    this.clearSelectedRows();
    this.setState({objectModalRowInfo: undefined});
    if ('uncataloged' !== this.props.viewType) this.props.fetchAllKeywordsAndValues(this.props.tabIndex);
     
    this.props.refreshTab(this.props.tabIndex);
  }

  async removeKeywords()
  {
    this.getSelectedObjects();
    if (!this.selectedObjects.length) return;

    if (this.immutableObjectCheck('keywords')) return;

    let bodyData = { objectIds: [] };
    
    for (let i = 0; i < this.selectedObjects.length; i++) bodyData.objectIds[bodyData.objectIds.length] = this.selectedObjects[i].objectId;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'removeAllAssociatedKeywords', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error removing all associated keywords');

    var text;
    if ('cataloged' === this.props.viewType)
      text = 'All associated keywords have been removed.  Your objects are now on the upload tab.';
    else
      text = 'All associated keywords have been removed.';

    this.context.postNotification('info', text);
    this.clearSelectedRows();
    this.refreshVaultViewTab();
  }

  removeQueryFilter(index)
  {
    this.props.removeQueryFilter(this.props.tabIndex, index);
  }

  render()
  {
    let objectTypePlaceholder = 'All Object Types';
    if (undefined !== this.props.objectTypePickerData)
    {
      for (let x = 0; x < this.props.objectTypePickerData.length; x++)
      {
        if (this.props.objectTypePickerData[x].selected)
        {
          objectTypePlaceholder = this.props.objectTypePickerData[x].objectType;
          break;
        }
      }
    }

    return(
      <div>
        {this.state.contentGalleryIsOpen && (
          <ContentGallery mediaList={this.mediaList} onClose={this.closeContentGallery} />
        )}
        <ConfirmationModal modalIsOpen={this.state.modalIsOpen} closeModal={this.closeConfirmationModal} modalText={this.state.modalText} />
        <Row style={{paddingTop: "10px", zIndex: 900}}> 
          <Col xs="12" lg="3" className="mb-3 pull-lg-9">
          { 'uncataloged' === this.props.viewType ? (
            <UploadFiles onComplete={this.uploadComplete} acceptableTypes={this.state.acceptableTypes} />
          ) : (
            <QueryBuilder filterDataChanged={this.filterDataChanged} queryKeywords={this.props.queryKeywords}
              savedFilterData={this.props.savedFilterData} filterData={this.props.filterData} 
              saveQueryFilter={this.saveQueryFilter} removeQueryFilter={this.removeQueryFilter} 
              selectedKeywords={this.props.selectedKeywords} queryValues={this.props.queryValues}
              addFilter={this.props.addFilter.bind(this, this.props.tabIndex)} viewType={this.props.viewType}
              clearAllFilters={this.props.clearAllFilters.bind(this, this.props.tabIndex)}
              matchAnyOrAllChanged={this.matchAnyOrAllChanged} matchAnyOrAll={this.props.matchAnyOrAll}
            />              
          ) }
          </Col>  
          <Col xs="12" lg="9" className="mb-3 push-lg-3">
          { this.state.vaultViewModalIsOpen && 
            <VaultViewModal onClose={this.vaultViewModalClosed} vaultViewModalIsOpen={this.state.vaultViewModalIsOpen} 
              component={this.state.vaultViewModalComponent} refreshVaultViewTab={this.refreshVaultViewTab} selectedObjects={this.selectedObjects}
              tabIndex={this.props.tabIndex} refreshQueryValues={this.props.refreshQueryValues} viewType={this.props.viewType}
              filterData={this.props.filterData} objectTypePickerData={this.props.objectTypePickerData} matchAnyOrAll={this.props.matchAnyOrAll}
            />
          }
          { this.state.objectModalIsOpen && 
            <ObjectModal onClose={this.objectModalClosed} objectModalIsOpen={this.state.objectModalIsOpen} 
              rowInfo={this.state.objectModalRowInfo} viewType={this.props.viewType}
              transformObject={this.transformObject} refreshVaultViewTab={this.refreshVaultViewTab} tabIndex={this.props.tabIndex}
              deleteRestoreOrPurge={this.deleteRestoreOrPurge} refreshQueryValues={this.props.refreshQueryValues}
              setActiveObjectModalTab={this.setActiveObjectModalTab} activeObjectModalTab={this.activeObjectModalTab}
              toggleImmutableObject={this.toggleImmutableObject} setStorageTier={this.setStorageTier}
              toggleCaptureDetail={this.toggleCaptureDetail} objectTypePickerData={this.props.objectTypePickerData} 
              filterData={this.props.filterData} matchAnyOrAll={this.props.matchAnyOrAll}
            />
          }
            <VaultViewButtonBar toggleSelectedRows={this.toggleSelectedRows} refreshButtonHandler={this.refreshVaultViewTab} 
              keywordsButtonHandler={this.keywordsButtonHandler} secureWeblinkButtonHandler={this.secureWeblinkButtonHandler}
              enrollButtonHandler={this.enrollButtonHandler} objectTypePickerData={this.props.objectTypePickerData} 
              objectTypePickerChanged={this.objectTypePickerChanged} objectTypePlaceholder={objectTypePlaceholder} 
              columnPickerData={this.state.columnPickerData} columnPickerChanged={this.columnPickerChanged}
              toggleGateway={this.props.toggleGateway} toggleColumnFilters={this.toggleColumnFilters}
              viewType={this.props.viewType} sharedOptionChanged={this.sharedOptionChanged} sharedOption={this.props.sharedOption}
              sharingButtonHandler={this.sharingButtonHandler} selectedRowsLength={this.state.selectedRows.length}
              generateEmbeddings={this.generateEmbeddings} openChatInterface={this.openChatInterface} imageSearch={this.imageSearch}
            />
            <VaultViewData viewType={this.props.viewType} enableColumnFilters={this.state.enableColumnFilters} sortColumn={this.state.sortColumn}
              vaultColumns={this.state.vaultColumns} keywordsButtonHandler={this.keywordsContextMenuHandler} openContentGallery={this.openContentGallery}
              saveColumnWidths={this.saveColumnWidths} vaultViewData={this.props.vaultViewData} selectedRows={this.state.selectedRows} 
              deleteRestoreOrPurge={this.deleteRestoreOrPurge} selectionHandler={this.selectionHandler} openDetailsModal={this.openDetailsModal} 
              secureWeblinkHandler={this.secureWeblinkButtonHandler} sortChanged={this.sortChanged} removeKeywords={this.removeKeywords}
              tabIndex={this.props.tabIndex} setTableRef={this.setTableRef} sharingButtonHandler={this.sharingButtonHandler} 
              refreshVaultViewTab={this.refreshVaultViewTab} generateEmbeddings={this.generateEmbeddings} 
            />                
          </Col>
        </Row>
      </div>        
    );
  }

  /**
   * Saves an altered column width preference in browser local storage
   */
  saveColumnWidths(resizedColumns)
  {
    this.context.appLocalStorage.saveColumnWidths(resizedColumns, this.vaultColumnWidths, this.columnWidthsLS);    
  }

  saveQueryFilter(savedFilterData)
  {
    this.props.saveQueryFilter(this.props.tabIndex, savedFilterData);
  }

  secureWeblinkButtonHandler(event)
  {
    this.getSelectedObjects();
    if (1 !== this.selectedObjects.length)
    {
      this.context.postNotification('error', 'You can only generate a weblink for one row. Select one row only.');
      return;
    } 

    this.setState(
    {
      vaultViewModalIsOpen: !this.state.vaultViewModalIsOpen,
      vaultViewModalComponent: 'secure weblink',
    });
  }

  selectionHandler(event, rowInfo, instance, contextMenuCallback)
  {
    if (typeof rowInfo === 'undefined' || this.disableSelectionHandler)
      return;

    let selectedRows = this.state.selectedRows;      
    let absoluteViewIndex = (rowInfo.page * rowInfo.pageSize) + rowInfo.viewIndex;

    if (event.shiftKey)
    {
      if (undefined !== this.currentViewIndex)
      {
        let max = Math.max(absoluteViewIndex, this.currentViewIndex);
        let min = Math.min(absoluteViewIndex, this.currentViewIndex);

        selectedRows = [];
        for (let x = min; x <= max; x++)
          selectedRows.push(instance.state.sortedData[x]._index);
      }
      else
        selectedRows.push(rowInfo.index);
    }
    else if (event.ctrlKey)
    {
      let x = this.state.selectedRows.indexOf(rowInfo.index);
      if (-1 === x)
      {
        selectedRows.push(rowInfo.index);
      }
      else
      {
        selectedRows.splice(x, 1);
      }
    }
    else
    {
      selectedRows = [];
      selectedRows.push(rowInfo.index);
    }

    this.currentViewIndex = absoluteViewIndex;

    if (undefined === contextMenuCallback) 
      this.setState({selectedRows: selectedRows});
    else
      this.setState({selectedRows: selectedRows}, contextMenuCallback);

    window.clearTextSelection();
  }

  setActiveObjectModalTab(tabIndex)                       // Keep track of the last opened tab...
  {
    this.activeObjectModalTab = tabIndex;
    this.context.appLocalStorage.setItem(this.activeObjectModalTabLS, tabIndex);
  }

  setTableRef(ref, tabIndex)
  {
    this.tableRefs[tabIndex] = ref;
  }

  sharedOptionChanged(sharedOption)
  {
    this.clearSelectedRows();
    this.props.sharedOptionChanged(sharedOption);
  }

  sharingButtonHandler(event)
  {
    this.getSelectedObjects();
    if (!this.selectedObjects.length)
    {
      this.context.postNotification('error', 'Select an object first.');
      return;
    }

    this.setState({vaultViewModalComponent: 'sharing', vaultViewModalIsOpen: !this.state.vaultViewModalIsOpen});
  }

  openContentGallery()
  {
    this.disableSelectionHandler = true;
    this.mediaList = [];

    for (let x = 0; x < this.state.selectedRows.length; x++)
    {
      if (null !== this.props.vaultViewData[this.state.selectedRows[x]].htmlElement) 
        this.mediaList.push(this.props.vaultViewData[this.state.selectedRows[x]]);
    }

    if (!this.mediaList.length)
    {
      this.context.postNotification('info', "None of the items you've selected can be viewed or played.");
      this.disableSelectionHandler = false;
      return;
    }

    this.setState({contentGalleryIsOpen: true});
  }

  async setStorageTier(storageTier)
  {
    let objectModalRowInfo = this.state.objectModalRowInfo;
    objectModalRowInfo.storageTier = storageTier;

    var bodyData = {};
    bodyData.objectId = objectModalRowInfo.objectId;
    bodyData.storageTier = storageTier;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'setStorageTier', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error changing storage tier.');    
    this.setState({objectModalRowInfo: objectModalRowInfo});
    this.context.postNotification('success', 'Object storage tier changed.');
  }

  sortChanged(sortColumn)
  {
    this.context.appLocalStorage.setItem(this.sortColumnLS, JSON.stringify(sortColumn));
  }

  toggleColumnFilters()
  {
    let enableColumnFilters = !this.state.enableColumnFilters;
    this.setState({enableColumnFilters: enableColumnFilters})
  }

  async toggleCaptureDetail()
  {
    let objectModalRowInfo = this.state.objectModalRowInfo;

    var bodyData = {};
    bodyData.objectId = objectModalRowInfo.objectId;
    bodyData.captureAccessDetail = ('Y' === objectModalRowInfo.captureAccessDetail ? 'N' : 'Y');

    objectModalRowInfo.captureAccessDetail = bodyData.captureAccessDetail;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'setCaptureAccessDetail', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error setting/unsetting capture access detail flag');    

    this.setState({objectModalRowInfo: objectModalRowInfo});
    this.context.postNotification('success', 'Capture access detail flag set/unset.');
  }

  async toggleImmutableObject(objectOrKeywords)
  {
    let objectModalRowInfo = this.state.objectModalRowInfo;

    var bodyData = {};
    bodyData.objectIds = [];
    bodyData.objectIds[0] = objectModalRowInfo.objectId;
    bodyData.objectOrKeywords = objectOrKeywords;

    if ('object' === objectOrKeywords)
    {
      if ('N' === objectModalRowInfo.immutableObject)
        objectModalRowInfo.immutableObject = 'Y';  
      else
        objectModalRowInfo.immutableObject = 'N';  

      bodyData.newState = objectModalRowInfo.immutableObject;
    }       
    
    if ('keywords' === objectOrKeywords)
    {
      if ('N' === objectModalRowInfo.immutableKeywords)
        objectModalRowInfo.immutableKeywords = 'Y';
      else
        objectModalRowInfo.immutableKeywords = 'N';

      bodyData.newState = objectModalRowInfo.immutableKeywords;
    }
    
    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'setImmutableState', bodyData);
    if ('success' !== result.status) return this.context.dbTwig.apiErrorHandler(result, 'Error setting/unsetting immutable flag');    

    this.setState({objectModalRowInfo: objectModalRowInfo});
  }

  toggleSelectedRows()
  {
    let selectedRows = [];

    for (let i = 0; i < this.tableRefs[this.props.tabIndex].state.sortedData.length; i++)
    {
      let index = this.tableRefs[this.props.tabIndex].state.sortedData[i]._index;
      if (this.state.selectedRows.indexOf(index) === -1)
        selectedRows.push(index);
    }

    this.setState({selectedRows: selectedRows});
  }

  transformObject(rowIndex)
  {
    this.props.transformObject(this.props.tabIndex, rowIndex);
    let objectModalRowInfo = this.state.objectModalRowInfo;
    objectModalRowInfo.versionedObject = 'Y';
    this.setState({objectModalRowInfo: objectModalRowInfo});
  }

  uploadComplete()
  {
    this.clearSelectedRows();
    this.refreshVaultViewTab();
  };

  vaultViewModalClosed()
  {
    this.setState({vaultViewModalIsOpen: !this.state.vaultViewModalIsOpen});
  }

  viewButtonHandlerEntry(rowInfo)
  {
    this.mediaList = [];
    this.mediaList[0] = rowInfo.row;
    this.setState({contentGalleryIsOpen: true});
  }
}

VaultViewTab.contextType = AppContext;

export default VaultViewTab